import { Button } from 'react-bootstrap';
import '../style/interactiveTutorials.css'
import {useCookies} from "react-cookie";
import { BsQuestionCircle } from 'react-icons/bs';
import {
  registerTutorials,
  startTutorial
} from 'react-interactive-tutorials'

import {TUTORIALS} from '../constants/tutorials'

registerTutorials(TUTORIALS)

const InteractiveTutorialCmp = () => {
  const [cookie, setCookie] = useCookies(['tutorial_complete'])
  if (!cookie.tutorial_complete) {
    startTutorial('demo')
    setCookie('tutorial_complete', true)
  } 

  return(
      <Button variant="light" onClick={async () => {
        await startTutorial('demo')
      }}>
          <BsQuestionCircle />
      </Button>
  )
}

export default InteractiveTutorialCmp;